export function initScrollReveal(selector = '.reveal', activeClass = 'active') {
    const isMobile = window.matchMedia("(max-width: 900px)").matches;

    const bottomMargin = isMobile ? "-120px" : "-50px";

    // Mit data-reveal-margin (z.B. "-30%") startet ein Element erst, wenn seine Oberkante so weit
    // über dem unteren Fensterrand ist. Gut für Abläufe, die man sonst halb ausserhalb des Bildes verpasst.
    const observers = new Map();

    const observerFor = (margin) => {
        if (!observers.has(margin)) {
            observers.set(margin, new IntersectionObserver((entries, obs) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add(activeClass);
                        obs.unobserve(entry.target);
                    }
                });
            }, {
                threshold: margin ? 0 : 0.15,
                rootMargin: `0px 0px ${margin || bottomMargin} 0px`
            }));
        }

        return observers.get(margin);
    };

    document.querySelectorAll(selector).forEach(el => observerFor(el.dataset.revealMargin).observe(el));
}
